import React, { useState } from "react"
import AnimatedImage from "../global/AnimatedImage"
import styled from "styled-components"
import parse from "html-react-parser"
import Button from "../global/Button"
import { FiMapPin } from "react-icons/fi"
import { FiPhoneCall } from "react-icons/fi"
import getListingSlug from "../../utils/getListingSlug"

const FeaturedBusinessComp = styled.section`
  background: var(--charcoal);
  color: var(--white);
  font-family: var(--font-reg);
  line-height: 1.5rem;
  padding: 0rem 2rem 4rem 0;
  position: relative;

  @media only screen and (min-width: 1024px) {
    padding: 8rem 2rem 12rem 2rem;
  }

  .wrapper {
    display: flex;
    flex-wrap: wrap;

    @media only screen and (min-width: 1024px) {
      flex-wrap: nowrap;
    }
  }

  .left,
  .right {
    width: 100%;

    @media only screen and (min-width: 1024px) {
      width: calc(50% - 2rem);
    }
  }

  .right {
    @media only screen and (min-width: 1024px) {
      margin-right: 6rem;
    }
  }

  .left {
    position: relative;
    /* padding-bottom:60%; */
    margin-top: 4rem;
    order: 2;

    @media only screen and (min-width: 1024px) {
      margin-top: 0;
      margin-bottom: 0;
      order: 1;
      padding-bottom: 0%;
      /* margin-right:6rem; */
    }
  }

  .featured-title {
    font-family: var(--font-bold);
    font-size: 2.2rem;
    margin-bottom: 2rem;
  }

  .excerpt {
    font-size: 0.9rem;
    margin-bottom: 2rem;

    @media only screen and (min-width: 1024px) {
      width: 80%;
    }

    p {
      margin-bottom: 1rem;
    }

    * {
      line-height: 1.2rem;
    }
  }

  .phone-wrap,
  .address-wrap {
    font-size: 0.9rem;
    display: flex;
    align-items: center;

    span {
      font-family: var(--font-bold);
    }

    svg {
      margin-right: 1rem;
      width: 19px;
      height: 19px;
      top: -1px;
      position: relative;
    }
  }

  .phone-wrap {
    margin-bottom: 2rem;
  }

  .address-wrap {
    margin-bottom: 1rem;
  }

  .offer-wrap {
    margin-bottom: 3rem;
    font-size: 0.9rem;
    border: 2px solid var(--white);
    padding: 2rem;

    .label {
      color: var(--brandColor);
      font-family: var(--font-bold);
      text-transform: uppercase;
      font-size: 1.4rem;
      margin-bottom: 1rem;
    }
  }
`

export default function FeaturedBusiness(data) {
  const featured = data.data

  return (
    <FeaturedBusinessComp className="featuredBusiness">
      <div className="wrapper">
        <div className="left">
          <AnimatedImage
            imgSrc={
              featured.acf_listings.image1.localFile.childImageSharp
                .gatsbyImageData
            }
            offsetX={"3rem"}
            offsetY={"3rem"}
            color={"brandColor"}
          />
        </div>
        <div className="right">
          <h4 className="featured-title">{featured.title}</h4>
          <div className="excerpt">
            {parse(featured.acf_listings.fullText.split("\n")[0])}
          </div>
          <div className="address-wrap">
            <FiMapPin />
            <span>{featured.acf_listings.address}</span>
          </div>
          <div className="phone-wrap">
            <FiPhoneCall />
            <span>{featured.acf_listings.phone}</span>
          </div>
          {featured?.acf_listings?.blackCardPromotion ? (
            <div className="offer-wrap">
              <div className="label">Offer</div>
              <div className="offer">
                {featured.acf_listings.blackCardPromotion
                  ? parse(featured.acf_listings.blackCardPromotion)
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
          <Button
            color="white"
            bg="brandColor"
            text={"Explore"}
            link={getListingSlug(featured)}
          />
        </div>
      </div>
    </FeaturedBusinessComp>
  )
}
